/** This file is auto generated by convertSvgToJsx.ts */

import icon from './dnb/list_medium'
export default icon
